export enum CustomerStatusEnum {
    ACTIVE = "Active",
    BLACKLISTED = "Blacklisted",
    INACTIVE = "Inactive"
}